const MIN_MS = Math.sqrt(8000);
const MAX_MS = Math.sqrt(10000);

export const getPathPoints = (envelope, width, height, hasRelease, hasLevel) => {
    width = width - 10;
    let attack = envelope.attackParameter.get();
    let decay = envelope.decayParameter.get();
    let sustain = envelope.sustainParameter.get();
    let release = envelope.releaseParameter.get();

    let total = Math.sqrt(attack + decay + release);
    let attackWidth = getXForMilli(attack, total, width);
    let decayWidth = getXForMilli(decay, total, width);
    let releaseWidth = hasRelease && release > 0 ? getXForMilli(release, total, width) : 0;
    let sustainWidth = Math.max(10, width - (attackWidth + decayWidth + releaseWidth));
    let levelY = hasLevel ? 5 + height - (Math.sqrt((envelope.level + 1) / 2) * height) : 5;
    levelY = Math.min(height-5, levelY);
    let sustainY = Math.min(5 + (height - (Math.sqrt(sustain) * (height))), height-5);

    return [
        5, hasLevel? height / 2 - 5 : height, // 
        attackWidth, levelY, // attack
        attackWidth + decayWidth, sustainY,  // decay
        attackWidth + decayWidth + sustainWidth, sustainY, // sustain 
        attackWidth + decayWidth + sustainWidth + releaseWidth, height // release
    ];

};

export const getXForMilli = (ms, total, width) => {
    return 5 + 0.8 * width * Math.sqrt(ms) / Math.max(MIN_MS, total);
}

export const getValueForParameter = (parameter, envelope, x, y, width, height) => {
    let attack = envelope.attackParameter.get();
    let decay = envelope.decayParameter.get();
    let sustain = envelope.sustainParameter.get();
    let release = envelope.releaseParameter.get();

    let total = Math.sqrt(attack + decay + release);

    if (x < 5) {
        return parameter.get();
    }

    let value = 1;

    if (parameter.name === 'Attack') {
        value = Math.min(
            MAX_MS,
            Math.max(MIN_MS, total) * (x - 5) / (0.8 * width));
    } else if (parameter.name === 'Decay') {
        decay = Math.max(MIN_MS, total) * (x - 5) / (0.8 * width) - Math.sqrt(attack);
        value = Math.min(
            MAX_MS,
            Math.max(0, decay));
    } else if (parameter.name === 'Sustain') {
        y = height - y;
        sustain = y / (height);
        value = Math.min(
            MAX_MS,
            Math.max(0, sustain));
    } else if (parameter.name === 'Level') {
        y = height - y;
        let level = y / (height);
        return 2*Math.pow(level, 2) - 1;
    } else if (parameter.name === 'Release') {
        release = Math.max(MIN_MS, total) * Math.max(0, width - x - 5) / ( width);
        value = Math.min(
            MAX_MS,
            Math.max(0, release));
    }
    return Math.pow(value, 2);
}
